import React from 'react';
import { Box, CheckBox, Text } from '@design-system/mobile';
import ConsultAgreeListItem from './ConsultAgreeListItem';
import useConusltAgree from './hooks/useConsultAgree';
import TrackingService from '@/services/tracking';
import { ConsultAgreeItem } from '@/types';

interface ConsultAgreeProps {
  consultAgreeItems: ConsultAgreeItem[];
}

const ConsultAgree = ({ consultAgreeItems }: ConsultAgreeProps) => {
  const {
    handleAllCheckBox,
    handleCheckBox,
    isAllagreeActive,
    register,
    watch,
  } = useConusltAgree();

  return (
    <Box
      pb={16}
      borderBottom="1px solid"
      borderBottomColor="pick_color.primary"
      {...TrackingService.tagGTM('consult_agree')}
    >
      <Box
        pb={12}
        mb="8px"
        borderBottom="1px solid"
        borderBottomColor="pick_color.primary"
      >
        <Text as="p" variant="headline5" color="color_chip.primary">
          개인정보 수집 동의
        </Text>
      </Box>
      <Box as="ul">
        <>
          <Box as="li" py={10}>
            <CheckBox
              labelOptions={{
                text: '모두 동의',
                textVariant: 'headline6',
              }}
              checked={isAllagreeActive === 'Y'}
              onChange={handleAllCheckBox}
              className="checkbox"
              {...TrackingService.tagGTM('consult_agree_button')}
            />
          </Box>
          {consultAgreeItems.map((item) => {
            return (
              <ConsultAgreeListItem
                key={item.id}
                id={item.id}
                title={item.title}
                description={item.description}
                name={item.name}
                checked={watch(item.name) === 'Y'}
                register={register}
                handleCheckBox={() => handleCheckBox(item.name)}
              />
            );
          })}
        </>
      </Box>
    </Box>
  );
};

export default React.memo(ConsultAgree);
